"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastMessage = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classnames = require("classnames");
var Icon_1 = require("components/Icon");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('timer', 'setTimer', undefined), (0, recompose_1.defaultProps)({ timeout: 6000 }), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        var _this = this;
        if (this.props.timeout && this.props.timeout === 0) {
            return;
        }
        var timer = setTimeout(function () {
            _this.props.removeToast(_this.props.message.uuid);
        }, this.props.timeout);
        this.props.setTimer(timer);
    },
    componentWillUnmount: function () {
        this.props.timer !== undefined && clearTimeout(this.props.timer);
        this.props.removeToast(this.props.message.uuid);
    }
}), recompose_1.pure);
var ToastMessagePure = function (props) { return (React.createElement("div", { className: classnames('sok-toast', props.message.type) },
    React.createElement("div", { onClick: function () {
            return props.dispatch && props.message.onClickActions.forEach(props.dispatch);
        } },
        React.createElement("span", null, props.message.title),
        React.createElement("span", null, props.message.message)),
    React.createElement("div", { onClick: function () { return props.removeToast(props.message.uuid); } },
        React.createElement(Icon_1.Icon, { className: 'fa-times' })))); };
exports.ToastMessage = enhance(ToastMessagePure);
